<template>
  <d-container fluid class="px-4 main-content-container">
    <!-- Page Header -->
    <d-row no-gutters class="py-4 page-header">
      <d-col col sm="4" class="mb-4 text-center text-sm-left mb-sm-0">
        <span class="text-uppercase page-subtitle">Revista</span>
        <h3 class="page-title">Adicionar</h3>
      </d-col>
    </d-row>

    <magazine-page/>
  </d-container>
</template>

<script>
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import { MODEL, _LOAD_MODEL_ } from '../components/MagazineModel';
import MagazinePage from '../components/MagazinePage.vue';

export default {
  name: 'magazine-create',
  components: {
    MagazinePage,
  },
  created() {
    Events.$emit('sidebarVisible', false);
  },
  mounted() {
    Events.$emit(_LOAD_MODEL_, cloneDeep(MODEL));
    this.$store.commit('setMagazine', cloneDeep(MODEL));
  },
};
</script>

